import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  CardMedia,
  Typography,
  CardTitle,
  Button
} from '@one-thd/sui-atomic-components';
import ProjectsHeader from '../ProjectsHeader';
import NullStateCreateProjectAction from './NullStateCreateProjectAction';
import nullStateConstants from '../../constants/nullStateConstants';
import {
  triggerProjectsInteractionAnalytics,
} from '../../utils/helpers';
import { useContainerWidth } from '../../hooks/useContainerWidth';

const LARGE_DESKTOP_BREAKPOINT = 1600; // SUI @3xl container query breakpoint

const DesktopNullView = ({
  componentId, isDashboardSnapshot
}) => {
  const [containerRef, containerWidth] = useContainerWidth();
  const isLargeDesktop = containerWidth >= LARGE_DESKTOP_BREAKPOINT;

  const {
    cardTitle,
    bodyText,
    imageAlt,
    imageUrl,
    buttonTextDesktop,
    learnMoreText,
  } = nullStateConstants;

  return (
    <div
      data-component="Projects"
      data-testid="projects-null-container"
      className="sui-h-full"
    >
      {/*
        Dashboard Snapshot (Figma "Desktop Null"): the tab already names the tool, so no
        header row; the snapshot's card has no padding of its own there, so the view supplies
        a 16px inset, and the image sits inside it with rounded corners.
      */}
      <div
        ref={containerRef}
        className={classNames('sui-flex sui-gap-4 sui-h-full', { 'sui-p-4': isDashboardSnapshot })}
      >
        <div className="sui-flex sui-flex-col sui-h-full sui-flex-1">
          {!isDashboardSnapshot && (
            <ProjectsHeader
              hideActions
              componentId={componentId}
            />
          )}
          {/* mt-2: 8px + ProjectsHeader pb-4 (16px on desktop) = 24px Figma gap */}
          <div className={classNames('sui-flex sui-flex-col sui-h-full', { 'sui-mt-2': !isDashboardSnapshot })}>
            <CardTitle
              headerVariant="h3"
              headerWeight="display"
              header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
            />
            <div className="sui-mt-2">
              <Typography>{bodyText}</Typography>
            </div>
            <div className="sui-mt-auto sui-pt-4">
              <div className="sui-flex sui-gap-4">
                <div className={isLargeDesktop ? 'sui-flex-none' : 'sui-flex-1'}>
                  <Button
                    variant="secondary"
                    fullWidth={!isLargeDesktop}
                    href={nullStateConstants.learnMoreLink}
                    onClick={() => triggerProjectsInteractionAnalytics({
                      action: 'button-click',
                      id: componentId,
                      component: 'learn more',
                    })}
                  >
                    {learnMoreText}
                  </Button>
                </div>
                <div className={isLargeDesktop ? 'sui-flex-none' : 'sui-flex-1'}>
                  <NullStateCreateProjectAction
                    cacheKey="desktop-null-view-create-project"
                    componentId={componentId}
                    buttonText={buttonTextDesktop}
                    fullWidth={!isLargeDesktop}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={classNames('sui-flex-1 sui-hidden @lg:sui-block sui-overflow-hidden', {
            'sui-rounded-md': isDashboardSnapshot
          })}
        >
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className="sui-w-full sui-h-full sui-transform sui-object-cover sui-object-center"
          />
        </div>
      </div>
    </div>
  );
};

DesktopNullView.propTypes = {
  componentId: PropTypes.string,
  isDashboardSnapshot: PropTypes.bool,
};
DesktopNullView.defaultProps = {
  componentId: '',
  isDashboardSnapshot: false,
};
export default DesktopNullView;
